import { render, staticRenderFns } from "./backtop.vue?vue&type=template&id=9e778ea2&scoped=true"
import script from "./backtop.vue?vue&type=script&lang=js"
export * from "./backtop.vue?vue&type=script&lang=js"
import style0 from "./backtop.vue?vue&type=style&index=0&id=9e778ea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e778ea2",
  null
  
)

export default component.exports